module.exports = __webpack_public_path__ + "static/img/13.1631a93.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/zh/13.png
// module id = l8o/
// module chunks = 0